import { render, staticRenderFns } from "./IsotopeHeader.vue?vue&type=template&id=e64a4382&"
import script from "./IsotopeHeader.vue?vue&type=script&lang=ts&"
export * from "./IsotopeHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports